import React, {Component} from 'react';
import {Grid, Paper, Typography} from 'material-ui';
import {getDisplayNameOrNull} from '../../components/helpers/helpers';
import {BackButton} from '../../components/buttons/BackButton';

class BlockViewContent extends Component {
    render() {
        const {block, classes} = this.props;

        return (
            <Grid container spacing={0}>
                <Grid item xs={12}>
                    <div className={classes.blockViewHeading}>
                        <p className={classes.blockViewLead}>
                            View details for: "{block.display_name}"
                        </p>
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <Paper elevation={2} className={classes.blockViewContent}>
                        <Grid container spacing={24}>
                            <Grid item md={6} sm={6} xs={12}>
                                <Typography variant="subheading">
                                    Block Type:
                                    <p
                                        className={
                                            classes.blockContentParagraph
                                        }
                                    >
                                        {getDisplayNameOrNull(
                                            block.block_type_name
                                        )}
                                    </p>
                                </Typography>
                            </Grid>
                            <Grid item md={6} sm={6} xs={12}>
                                <Typography variant="subheading">
                                    Destination:
                                    <p
                                        className={
                                            classes.blockContentParagraph
                                        }
                                    >
                                        {getDisplayNameOrNull(
                                            block.destination_name
                                        )}
                                    </p>
                                </Typography>
                            </Grid>
                            <Grid item md={6} sm={6} xs={12}>
                                <Typography variant="subheading">
                                    Trip Format:
                                    <p
                                        className={
                                            classes.blockContentParagraph
                                        }
                                    >
                                        {getDisplayNameOrNull(
                                            block.meta_category_name
                                        )}
                                    </p>
                                </Typography>
                            </Grid>
                            <Grid item md={6} sm={6} xs={12}>
                                <Typography variant="subheading">
                                    Type of Work:
                                    <p
                                        className={
                                            classes.blockContentParagraph
                                        }
                                    >
                                        {getDisplayNameOrNull(
                                            block.type_of_work_name
                                        )}
                                    </p>
                                </Typography>
                            </Grid>
                            <Grid item md={6} sm={6} xs={12}>
                                <Typography variant="subheading">
                                    Name:
                                    <p
                                        className={
                                            classes.blockContentParagraph
                                        }
                                    >
                                        {block.display_name}
                                    </p>
                                </Typography>
                            </Grid>
                            <Grid item md={6} sm={6} xs={12}>
                                <Typography variant="subheading">
                                    Title:
                                    <p
                                        className={
                                            classes.blockContentParagraph
                                        }
                                    >
                                        {block.title}
                                    </p>
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="subheading">
                                    Button Text:
                                    <p
                                        className={
                                            classes.blockContentParagraph
                                        }
                                    >
                                        {block.button_text}
                                    </p>
                                </Typography>
                            </Grid>

                            <Grid item xs={12}>
                                <Typography variant="subheading">
                                    Body:
                                    <p
                                        className={
                                            classes.blockContentParagraph
                                        }
                                        dangerouslySetInnerHTML={{
                                            __html: block.body,
                                        }}
                                    ></p>
                                </Typography>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
                <Grid container spacing={0}>
                    <Grid item xs={12} className={classes.buttons}>
                        <BackButton
                            link={'/blocks'}
                            variant="raised"
                            className="floatRight"
                        />
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

export default BlockViewContent;



// WEBPACK FOOTER //
// ./src/containers/blocks/BlockViewContent.jsx